'use client';

import { throttle } from '@/utils';
import { Image } from '@nextui-org/react';
import Link from 'next/link';
import { useCallback, useEffect, useState } from 'react';
import { btnLink } from '../utils';
import { Poppins } from 'next/font/google';


const inter = Poppins({ weight: ['400', '600'], subsets: ['latin'] });

export default function Banner() {

  const [show, setShow] = useState(false);
  const [classShow, setClassShow] = useState(false);

  useEffect(() => {
    setClassShow(true);
  }, []);

  const handleScroll = useCallback(throttle(() => {
    // 获取滚动条的高度
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

    // 获取屏幕的高度
    // const screenHeight = window.innerHeight;
    // 判断滚动条的高度是否超出了屏幕的高度
    if (scrollTop > 300) {
      // console.log("滚动条的高度超出了屏幕的高度");
      setShow(true);
    } else {
      // console.log("滚动条的高度没有超出屏幕的高度");
      setShow(false);
    }


  }, 200), [setShow]);

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <>
    {/* pc */}
    <div className={`${show ? 'flex' : 'hidden'}  max-md:hidden w-full h-[80px] bg-[#00183F] items-center justify-center fixed left-0 bottom-0 z-50`}>
      <div className='w-[1280px] flex'>
        <Image
          src='/pc-banner.png'
          alt='bookey'
          width={713}
          height={80}
        />
        <div className="btns pl-[63px] pt-1 pr-2">
          <Link href={btnLink.ios} target='_blank'>
            <Image
              src='/apple-store.png'
              radius='none'
              alt='app store'
              width={84}
              height={25}
            />
          </Link>
          <Link href={btnLink.android} target='_blank'>
            <Image
              src='/google-play-badge.png'
              classNames={{
                wrapper: 'pt-1',
              }}
              radius='none'
              alt='app store'
              width={84}
              height={25}
            />
          </Link>
          {
            classShow ?
            <p className={`${inter.className} pt-[2px] text-white text-12-17`}>Scan to Download</p>
              : null
          }
        </div>
        <Image
          src='/xr-code.png'
          alt='qr-code'
          width={80}
          height={80}
          radius='none'
        />
      </div>
    </div>
    </>
  );
}
